import React from "react";

import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import AddIcon from '@mui/icons-material/Add';
import { Box, Button, TextField, Typography } from "@mui/material";

import FormModal from "../../../../../components/Dashboard/formModal/FormModal";
import styles from "./styles";
import { closeDeveloperModal, isDeveloperModalOpen } from "../../../../../redux/slices/modal/ModalSlice";
import { addDeveloper } from "../../../../../redux/slices/developers/devlopersSlice";

const DeveloperModal = () => {
  const validationSchema = z.object({
    name: z.string().trim().min(1, { message: "Name is required" }),
    email: z.string().trim().email({ message: "Invalid email format" }).refine((email) => {
      const domain = email.split('@')[1];
      return domain === 'purelogics.com' || domain === 'purelogics.net';
    }, { message: "Email must be from purelogics.com or purelogics.net" }),
  });

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors }
  } = useForm({
    resolver: zodResolver(validationSchema),
    defaultValues: {
      name: "",
      email: "",
    }
  });

  const dispatch = useDispatch();
  const isOpen = useSelector(isDeveloperModalOpen);

  const handleClose = () => {
    reset();
    dispatch(closeDeveloperModal());
  };

  const onSubmit = (data, e) => {
    e.preventDefault();
    dispatch(addDeveloper(data));
    reset();
  };

  return (
    <FormModal
      isOpen={isOpen}
      handleClose={handleClose}
      title="Add Developer"
      styles={styles}
      isIcon={true}
    >
      <form autoComplete="off" onSubmit={handleSubmit(onSubmit)}>
        <Box pt={5}>
          {/* Developer Name */}
          <Box sx={styles.modalFieldBox}>
            <Typography component="span" variant="body1">
              Developer Name
            </Typography>
            <TextField
              placeholder="Add developer name here"
              id="name"
              type="text"
              {...register("name")}
              helperText={errors.name?.message}
              error={Boolean(errors.name)}
              sx={styles.modalTextField}
            />
          </Box>
          {/* Developer Email */}
          <Box sx={styles.modalFieldBox} pt={2}>
            <Typography component="span" variant="body1">
              Developer Email
            </Typography>
            <TextField
              placeholder="Add developer email here"
              id="email"
              type="email"
              {...register("email")}
              helperText={errors.email?.message}
              error={Boolean(errors.email)}
              sx={styles.modalTextField}
            />
          </Box>
          {/* Submit button */}
          <Box pt={4} sx={styles.modalFlexBox}>
            <Button
              variant="contained"
              type="submit"
              sx={styles.modalBtn}
            >
              <AddIcon />
              Add Developer
            </Button>
          </Box>
        </Box>
      </form>
    </FormModal>
  );
};

export default DeveloperModal;
